import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import MomentPropTypes from 'react-moment-proptypes';
import CardSectionHeading from '../CardSectionHeading';
import CardRowKeyVal from '../CardRowKeyVal';
import moment from 'moment-timezone';
import get from 'lodash/get';
import map from 'lodash/map';

const propTypes = {
  details: PropTypes.shape({
    extension_allowed: PropTypes.bool,
    drivers: PropTypes.array,
    rental_company: PropTypes.string,
    rental_started: MomentPropTypes.momentString,
    rental_ended: MomentPropTypes.momentString,
  }),
};

const defaultProps = {
  details: {},
};

class PolicyDetailsRentalCar extends PureComponent {

  formatDate(dateStr) {
    return moment(dateStr, 'YYYY-MM-DD').format('MMM DD, YYYY');
  }

  get driverNodes() {
    return map(get(this.props.details, 'drivers'), (driver, i) => {
      const label = driver.is_main_driver ? 'Primary driver' : 'Additional driver';
      return (
        <CardRowKeyVal
          key={i}
          title={label}
          detail={driver.name}
        />
      )
    });
  }

  render() {
    const {
      coverage_start_date,
      coverage_end_date,
      plan,
    } = this.props;
    const {
      rental_started,
      rental_ended,
      rental_company,
    } = this.props.details;

    return (
      <div>
        <CardRowKeyVal
          title="Coverage period"
          detail={`From ${this.formatDate(coverage_start_date)} to ${this.formatDate(coverage_end_date)}`}
        />
        <CardSectionHeading>
          Rental Details
        </CardSectionHeading>
        {this.driverNodes}
        <CardRowKeyVal
          title="Rental agency"
          detail={rental_company}
        />
        <CardRowKeyVal
          title="Reservation dates"
          detail={`From ${this.formatDate(rental_started)} to ${this.formatDate(rental_ended)}`}
        />
        <CardSectionHeading>
          Policy Details
        </CardSectionHeading>
        <CardRowKeyVal
          title="Plan type"
          detail={get(plan, 'title')}
        />
        <CardRowKeyVal
          title="Coverage"
          detail={get(plan, 'subtitle')}
        />
      </div>
    );
  }
}

PolicyDetailsRentalCar.propTypes = propTypes;
PolicyDetailsRentalCar.defaultProps = defaultProps;

export default PolicyDetailsRentalCar;
